import React from 'react'

const PharmaBilling = () => {
  return (
    <div>PharmaBilling</div>
  )
}

export default PharmaBilling;